class BNStatsCounter {

    constructor(selector = '.bn-stat-content h3') {

        this.counters =
            document.querySelectorAll(selector);

        if (!this.counters.length) return;

        this.init();
    }

    init() {

        const observer =
            new IntersectionObserver(
                entries => {

                    entries.forEach(entry => {

                        if (entry.isIntersecting) {

                            this.animate(
                                entry.target
                            );

                            observer.unobserve(
                                entry.target
                            );
                        }

                    });

                },
                {
                    threshold: 0.4
                }
            );

        this.counters.forEach(counter => {

            const text =
                counter.textContent.trim();

            if (
                text.includes('/')
            ) {
                return;
            }

            observer.observe(counter);

        });
    }

    animate(counter) {

        const originalText =
            counter.textContent.trim();

        const number =
            parseInt(
                originalText.replace(
                    /[^0-9]/g,
                    ''
                ),
                10
            );

        if (
            isNaN(number)
        ) {
            return;
        }

        const suffix =
            originalText.replace(
                number,
                ''
            );

        const duration = 2000;

        let start = null;

        const step = timestamp => {

            if (!start) {
                start = timestamp;
            }

            const progress =
                Math.min(
                    (timestamp - start) /
                    duration,
                    1
                );

            const ease =
                1 -
                Math.pow(
                    1 - progress,
                    3
                );

            const current =
                Math.floor(
                    ease * number
                );

            counter.textContent =
                current + suffix;

            if (
                progress < 1
            ) {

                requestAnimationFrame(
                    step
                );

            } else {

                counter.textContent =
                    originalText;
            }
        };

        requestAnimationFrame(step);
    }
}

document.addEventListener(
    'DOMContentLoaded',
    () => {

        new BNStatsCounter();

    }
);